(function () {
  const DESKTOP_BREAKPOINT = 1000;
  const PDP_ROOT = '.product-single__meta';

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function setImportant(el, prop, value) {
    if (!el) return;
    el.style.setProperty(prop, value, 'important');
  }

  function isPdpContainer(container) {
    return container && container.closest(PDP_ROOT);
  }

  function fixContainer(container) {
    if (!container || !container.classList.contains('nosto-swiper-container')) return;
    if (!isPdpContainer(container)) return;

    setImportant(container, 'height', 'auto');
    setImportant(container, 'min-height', '0');

    const wrapper = container.querySelector('.swiper-wrapper');
    if (wrapper) {
      setImportant(wrapper, 'height', 'auto');
      setImportant(wrapper, 'min-height', '0');

      if (isDesktop()) {
        setImportant(wrapper, 'display', 'flex');
        setImportant(wrapper, 'flex-direction', 'column');
        setImportant(wrapper, 'transform', 'none');
        setImportant(wrapper, 'gap', '8px');
        setImportant(wrapper, 'row-gap', '8px');
      }
    }

    container.querySelectorAll('.swiper-slide').forEach(function (slide) {
      setImportant(slide, 'height', 'auto');
      setImportant(slide, 'min-height', '0');
      setImportant(slide, 'margin', '0');
      setImportant(slide, 'padding', '0');

      if (isDesktop()) {
        setImportant(slide, 'display', 'contents');
      }
    });

    const swiper = container.swiper;
    if (swiper && isDesktop()) {
      try {
        swiper.allowTouchMove = false;
        swiper.disable();
      } catch (e) {}
    }
  }

  function scan() {
    document.querySelectorAll(PDP_ROOT + ' .nosto-swiper-container').forEach(fixContainer);
  }

  function observe() {
    const meta = document.querySelector(PDP_ROOT);
    if (!meta) return;

    let scheduled = false;
    const scheduleScan = function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        scan();
      });
    };

    const observer = new MutationObserver(function (mutations) {
      const shouldScan = mutations.some(function (mutation) {
        return mutation.type === 'childList' || mutation.type === 'attributes';
      });

      if (shouldScan) scheduleScan();
    });

    observer.observe(meta, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });

    scan();
  }

  function init() {
    observe();
    window.addEventListener('resize', scan);
    window.addEventListener('load', scan);
    [250, 500, 1000, 1500, 3000].forEach(function (delay) {
      setTimeout(scan, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
